// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1TL0e","noInteraction":"EventWrapper_noInteraction__20zAN","pointerPassthrough":"EventWrapper_pointerPassthrough__1t4U3"};